/**
 * @Author: v_jppjpeng
 * @Date: 2024-05-30 11:22:40
 * @Explain: 联系人 - 注册表单
 */

// api
//  type
import { ActionTypeEnum } from '@/definition/common/data.d';
import {
  BuildFormDataType,
  BuildSelectedTextConfig,
  StepEnum,
} from '@/pages/contactManage/utils/typings/sign-up-form';
// utils

/** 表单跳转 - 信息缓存类型 */
export type FormCacheType = {
  formUuid: string;
  method?: number;
  isSettingEmail: boolean;
  action: ActionTypeEnum;
  stepId: StepEnum;
  url: string;
};

/** 表单跳转 - 默认信息缓存 */
export const defaultFormCache = {
  formUuid: '',
  method: 0,
  isSettingEmail: false,
  action: ActionTypeEnum.ADD,
  stepId: StepEnum.BUILD,
  url: '',
};

/** 参数声明 */
export type ContactSignUpFormState = {
  /** 注册表单 */
  signUpFormData: BuildFormDataType[];
  /** 选中文本配置 */
  selectedTextConfig: BuildSelectedTextConfig;
  /** 表单跳转 - 信息缓存 */
  formCache: FormCacheType;
  /** 需要的配置 */
  formConfig: [];
};

export type ModelType = {
  namespace: string;
  state: ContactSignUpFormState;
  reducers: {
    /** 注册表单 - 构建表单 */
    setSignUpFormData: (
      state: ContactSignUpFormState,
      action: { payload: any },
    ) => any;
    /** 选中文本配置 */
    setSelectedTextConfig: (
      state: ContactSignUpFormState,
      action: { payload: any },
    ) => any;
    /** 设置表单跳转 - 信息缓存 */
    setFormCache: (
      state: ContactSignUpFormState,
      action: { payload: any },
    ) => any;
    /** 设置表单跳转 - 重置信息缓存 */
    resetFormCache: (
      state: ContactSignUpFormState,
      action: { payload: any },
    ) => any;
    /** 设置表单跳转 - 重置信息缓存 */
    setFormConfig: (
      state: ContactSignUpFormState,
      action: { payload: any },
    ) => any;
  };
};

const ContactSignUpFormModel: ModelType = {
  namespace: 'ContactSignUpFormModel',
  state: {
    signUpFormData: [],
    selectedTextConfig: {
      index: -1,
      selectedText: '',
      replaceTextKey: '',
    },
    /** 表单跳转 - 信息缓存 */
    formCache: defaultFormCache,
    formConfig: [],
  },
  reducers: {
    setSignUpFormData(state, action) {
      return {
        ...state,
        signUpFormData: action.payload,
      };
    },
    setSelectedTextConfig(state, action) {
      return {
        ...state,
        selectedTextConfig: action.payload,
      };
    },
    setFormCache(state, action) {
      return {
        ...state,
        formCache: action.payload,
      };
    },
    resetFormCache(state, action) {
      return {
        ...state,
        formCache: defaultFormCache,
      };
    },
    /** 设置需要设置的配置
     * 9.表单
     */
    setFormConfig(state, action) {
      return {
        ...state,
        formConfig: action.payload,
      };
    },
  },
};

export default ContactSignUpFormModel;
